import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap';
import httpClient from '../../../http/HttpRequest';
import { useTranslation } from 'react-i18next';
import Alert from '../../../feature/Alert';
import { CATEGORT_LIST, UNIT_LIST, ADD_PRODUCT, GET_PRODUCT } from '../../../data/url';
import FormLayout from '../layout/FormLayout';

export default function AddProduct({ show, handleClose, uniqueId }) {
    const id = uniqueId ? uniqueId : undefined;  
    const { t } = useTranslation();
    const [directSubmit, setDirectSubmit] = useState(1);
    const action = typeof id === 'undefined' ? 'ADD' : 'UPDATE';
    const [unit, setUnit] = useState([]);
    const [category, setCatgory] = useState([]);
    const [formData, setFormData] = useState({
        formTitle: 'Add Product',
        formFields: [
            { label: 'name', id: 'product_name', type: 'text', name: 'product_name', placeholder: 'enter_product_name', value: '', required: true, className: "col-md-4" },
            { label: 'category', id: 'category', type: 'select', select: true, name: 'category', value: '', required: true, options: [], className: "col-md-4", btn: { label: "New", link: "/root/product/actionCategory" } },
            { label: 'price', id: 'price', type: 'number', name: 'price', placeholder: 'enter_price', value: '', required: true, className: "col-md-4" },
            { label: 'gst_included', id: 'gst_included', type: 'checkbox', name: 'gst_included', value: '', options: [{ label: "YES", value: "1" }], className: "col-md-4" },
            { label: 'gst', id: 'gst_rate', type: 'number', name: 'gst_rate', placeholder: 'enter_gst_rate', value: '0', className: "col-md-4" },
            { label: 'stock', id: 'stock_quantity', type: 'number', name: 'stock_quantity', placeholder: 'enter_stock', value: '0', className: "col-md-4" },
            { label: 'unit', id: 'unit', type: 'select', select:true, name: 'unit', value: '', required: true, options: [], className: "col-md-4", btn: { label: "New", method: "unitModal" } },
            { label: 'hsn_code', id: 'hsn_code', type: 'text', name: 'hsn_code', placeholder: 'enter_hsn_code', value: '', className: "col-md-4" },
            { label: 'sac_code', id: 'sac_code', type: 'text', name: 'sac_code', placeholder: 'enter_sack_code', value: '', className: "col-md-4" },
            { label: 'desc', id: 'description', type: 'textarea', name: 'description', placeholder: 'enter_desc', value: '', className: "col-md-4" },
        ],
        formErrors: { product_name: '', category: '', price: '', gst_included: '', gst_rate: '', stock_quantity: '', unit: '', hsn_code: '', sac_code: '', description: '' },
    });

    useEffect(() => {
        if (show) {
            if (unit.length === 0) {
                getUnit();
            }
            if (category.length === 0) {
                getCategoryData();
            }         
           
            if (action === 'UPDATE') {
                setFormData(prevFormData => {
                    const statusFieldExists = prevFormData.formFields.some(field => field.id === 'status');
                    if (!statusFieldExists) {
                        const newFormField = {
                            label: 'status', id: 'status', type: 'radio', name: 'status', value: '', required: true, className: "col-md-4", options: [
                                { label: 'active', value: "1", class: "success" },
                                { label: 'deactive', value: "2", class: "danger" },
                            ]
                        };
                        const newFormErrors = {
                            ...prevFormData.formErrors,
                            status: ''
                        };
                        const updatedFormFields = [...prevFormData.formFields, newFormField];
                        return {
                            ...prevFormData,
                            formFields: updatedFormFields,
                            formErrors: newFormErrors
                        };
                    }
                    return prevFormData;
                });                
            }
        }

    }, [id, show]);
    
    useEffect(() => {
        if (id && category.length > 0) {
            getProductData();
        }
    },[category,id] )

    const getCategoryData = async (e) => {
        const res = await httpClient.post(CATEGORT_LIST, {});
        if (res.requestStatus === "OK") {
            const result = res.result;
            if (result.status === 1) {              
                let options = [];
                result.data.forEach((row, index) => {
                    options.push({ label: row.category_name, value: row.category_id });
                });
                setCatgory(options);
                updateFormFieldOptions(options, 'category');
            }
        }
    }

    const getUnit = async (e) => {
        const res = await httpClient.post(UNIT_LIST, {});
        if (res.requestStatus === "OK") {
            const result = res.result;
            if (result.status === 1) {         
                let options = [];
                result.data.forEach((row, index) => {
                    options.push({ label: row.name, value: row.id });
                });
                setUnit(options);
                updateFormFieldOptions(options, 'unit');
            }
        }
    }

    const getProductData = async () => {
        if (id) {
            const res = await httpClient.post(GET_PRODUCT, { product_id: id });
            if (res.requestStatus === 'OK') {
                const result = res.result;
                if (result.status === 1) {                 
                    setFormData(prevFormData => {
                        const updatedFormFields = prevFormData.formFields.map(field => {
                            if (field.name in result.data) {
                                if (field.name === 'category') {
                                    const c = category.find(element => element.value === result.data[field.name]);
                                    field.value = c;
                                } else if (field.name === 'unit') {
                                    const c = unit.find(element => element.value === result.data[field.name]);
                                    field.value = c;
                                } else{
                                    field.value = result.data[field.name];
                                }
                                
                            }
                            return field;
                        });
                        return {
                            ...prevFormData,
                            formFields: updatedFormFields,
                        };
                    });
                } else {
                    Alert.error(res.message);                   
                }
            }
        }
    };

    const dataChange = (fieldName) => {
        if (fieldName === 'unit') {
            getUnit();
        }
    }

    const updateFormFieldOptions = (newOptions, fieldName) => {
        setFormData(prevFormData => {
            const updatedFormFields = prevFormData.formFields.map(field => {
                if (field.name === fieldName) {
                    return {
                        ...field,
                        options: newOptions,
                    };
                }
                return field;
            });
            return {
                ...prevFormData,
                formFields: updatedFormFields,
            };
        });
    };


    function handleFieldChange(fieldName, value) {
        setDirectSubmit(0);
        setFormData((prevFormData) => {
            const updatedFormFields = prevFormData.formFields.map((field) =>
                field.name === fieldName ? { ...field, value: value } : field
            );
            return {
                ...prevFormData,
                formFields: updatedFormFields,
            };
        });
    }

    function handleFieldBlur(fieldName, value) {
        setDirectSubmit(0);
        validateField(fieldName, value);
    }

    function validateField(fieldName, value) {
        setFormData((prevFormData) => {
            const updatedErrors = { ...prevFormData.formErrors };
            if (fieldName === 'product_name') {
                updatedErrors.product_name = value.trim() === '' ? 'field_required' : '';
            }
            if (fieldName === 'category') {
                updatedErrors.category = value === '' ? 'field_required' : '';
            }
            if (fieldName === 'price') {
                updatedErrors.price = value.trim() === '' ? 'field_required' : '';
            }
            if (fieldName === 'unit') {
                updatedErrors.unit = value === '' ? 'field_required' : '';
            }
            return {
                ...prevFormData,
                formErrors: updatedErrors,
            };
        });

        return formData.formErrors;

    }

    function handleSubmit(e) {
        e.preventDefault();
        let post = {};
        let hasErrors = false;
        const updatedFormFields = formData.formFields.map((field) => {
            const allError = validateField(field.name, field.value);
            const error = allError[field.name];
            if (error !== '' && typeof error !== 'undefined') {
                hasErrors = true;
            } else {
                if (typeof field.value === 'object' && field.value !== null) {
                    post[field.name] = field.value.value;
                }else{
                    post[field.name] = field.value;
                }
              
            }
            return field;
        });
        setFormData((prevFormData) => ({
            ...prevFormData,
            formFields: updatedFormFields,
        }));
        if (!hasErrors && directSubmit === 0) {
            if (action === 'UPDATE') post['product_id'] = id;
            subtmitData(post);
        } else {
            if (action === 'UPDATE') {
                Alert.warning(t('you_did_not_change_anything'));
            } else {
                Alert.warning(t('mandetory_fields'));
            }
        }
    }

    const subtmitData = async (post) => {
        const res = await httpClient.post(ADD_PRODUCT, post);
        if (res.requestStatus === "OK") {
            const result = res.result;
            if (result.status === 1) {
                Alert.success(result.message);
                closeModal({ status: "RESULT_OK" });
            } else {
                Alert.failure(result.message);
            }
        }
    }

    function handleReset() {
        const updatedFormFields = formData.formFields.map((field) => ({
            ...field,
            value: '',
        }));

        setFormData((prevFormData) => ({
            ...prevFormData,
            formFields: updatedFormFields,
            formErrors: {},
        }));
    }

    const closeModal = (action = {}) => {
        handleClose('product', action);
    }

    return (
        <Modal show={show} onHide={closeModal} keyboard={false} backdrop="static" size="lg">
            <Modal.Header>
                <Modal.Title>{action == "ADD" ? t('add_product') : t('edit_product')}</Modal.Title>
                <button type="button" className="close" aria-label="Close" onClick={closeModal}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </Modal.Header>
            <Modal.Body>
                <FormLayout
                    formTitle={formData.formTitle}
                    formFields={formData.formFields}
                    formErrors={formData.formErrors}
                    onFieldChange={handleFieldChange}
                    onFieldBlur={handleFieldBlur}
                    onSubmit={handleSubmit}
                    handleReset={handleReset}
                    runtimeDataChange={dataChange}
                    isModal={true}
                />
            </Modal.Body>
        </Modal >
    )
}
